<p [translate]="'PEPCONNECT_TOP_NAV_TITLE'"></p>
<app-video-js-player #previewPepConnectionsPlayer videoId="preview-pepconnections"
    [src]="cloudMedia.Utils.cloudTransformUrl('FEED_USER_LEARN_MORE_VIDEO_MP4' | translate)"
    [poster]="cloudMedia.Utils.cloudTransformUrl('FEED_USER_LEARN_MORE_VIDEO_THUMB' | translate)"
    [options]="{ fluid: true }">
    <track
        [src]="cloudMedia.Utils.cloudTransformUrl('@@CONTENTURL@@/CMS/Vtts/7f61ad9b-a04b-430a-bb40-6d7dc3e15547.vtt')"
        label="Português (Brazil)" srclang="pt" kind="captions">
</app-video-js-player>
